export interface IModalState {
  visible: boolean;
  modalStatus: TModalStatus;
}

export type TModalStatus = TModalStatusSuccess | TModalStatusError;

export type TModalStatusSuccess = { status: EModalStatus.Init | EModalStatus.Success };

export type TModalStatusError = { status: EModalStatus.Failed; error: TModalError };

export type TModalError = {
  title: string;
  description: string;
};

export enum EModalStatus {
  Init = 'init',
  Success = 'success',
  Failed = 'failed',
}
